import React, {useEffect} from 'react';
import '../styles/background.scss'
import { useThemeManager } from '../Context/ThemeManager';
function Background() {
  const {theme} = useThemeManager();
  useEffect(() => {
          document.documentElement.style.setProperty('--bg', theme.bg);
      
    }, []);
  return (
    
   
      <div class="area" >
            <ul class="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
    </div >
    
  );
}

export default Background;